import styles from "../style.module.scss";
import React from "react";
import {initialReviewQuestionDefinition} from "../utils/transformField";

/**
 * @typedef {Object} ReviewItem
 * @property {string} grade
 * @property {string} score
 * @property {string} reasoning
 *
 * @param ReviewItem[] reviewTable
 * @param {string} finalQuestion
 * @param {function} updateReviewTable
 * @param {function} updateFinalQuestion
 */
const ReviewBuilder = ({
                           reviewTable,
                           finalQuestion,
                           updateReviewTable,
                           updateFinalQuestion,
}) => {
    const handleChange = (index, field, value) => {
        const newTable = [...reviewTable];
        newTable[index][field] = value;
        updateReviewTable(newTable);
    }
    const handleDeleteQuestion = (index) => {
        const newTable = [ ...reviewTable ];
        newTable.splice(index, 1);
        updateReviewTable(newTable);
    }
    const handleAddQuestion = () => {
        const newTable = [ ...reviewTable ];
        newTable.push(JSON.parse(JSON.stringify(initialReviewQuestionDefinition)));
        updateReviewTable(newTable);
    }
    const handleFinalQuestionChange = (value) => {
        updateFinalQuestion(value);
    }
    return (
        <div>
            <h1>טופס חוות דעת לקטור</h1>
            {reviewTable.map((reviewItem, index) => (
                <div className={styles.CardsWrraper}>
                    <div key={index} className={styles.inputField}>
                        <h3 className={styles.titleField}>{"שאלה " + (index + 1)}</h3>
                        <label>שדה חובה:</label>
                        <input
                            type="checkbox"
                            checked={reviewItem.required}
                            onChange={(e) => handleChange(index, "required", e.target.checked)}
                        />
                        <div className={styles.CardsWrraper}>
                            <input
                                type="text"
                                value={reviewItem.grade}
                                onChange={(e) => handleChange(index, "grade", e.target.value)}
                                className='style_inp__eLH4y'
                            />
                        </div>
                        <div className={styles.CardsWrraper}>
                            <label>נדרש ציון:</label>
                            <input
                                type="checkbox"
                                checked={reviewItem.hasScore}
                                onChange={(e) => handleChange(index, "hasScore", e.target.checked)}
                            />
                        </div>
                        <div className={styles.CardsWrraper}>
                            <label>שדה בחירה:</label>
                            <input
                                type="checkbox"
                                checked={!!(reviewItem.isSelect ?? false)}
                                onChange={(e) => handleChange(index, "isSelect", e.target.checked)}
                            />
                        </div>
                        <div className={styles.CardsWrraper}>
                            <label>כלול בציון סופי</label>
                            <input
                                type="checkbox"
                                checked={!!(reviewItem.forScore ?? true)}
                                onChange={(e) => handleChange(index, "forScore", e.target.checked)}
                            />
                        </div>
                        {reviewItem.hasScore ?? true ?
                            (<div className={styles.CardsWrraper}>
                                <label>ציון מקסימום</label>
                                <input
                                    type="number"
                                    value={reviewItem.maxScore ?? 10}
                                    onChange={(e) => handleChange(index, "maxScore", e.target.value)}
                                    className='style_inp__eLH4y'
                                />
                            </div>)
                        : null}
                        {
                            reviewItem.isSelect ?? false ?
                            (
                                <div className={styles.CardsWrraper}>
                                    <label>אפשרויות, מופרד על ידי פסיקים:</label>
                                    <input
                                        type="text"
                                        value={reviewItem.options ?? ""}
                                        onChange={(e) => handleChange(index, "options", e.target.value)}
                                        className='style_inp__eLH4y'
                                    />
                                </div>
                            )
                            : null
                        }
                        <button onClick={(e) => handleDeleteQuestion(index)} className={styles.Btn + " style_btn__APPaZ.style_small__nlrzy"}>מחק שאלה</button>
                    </div>
                </div>
            ))}
            <button onClick={(e) => handleAddQuestion()} className={styles.Btn + " style_btn__APPaZ.style_small__nlrzy"}>הוסף שאלה</button>
            <div className={styles.CardsWrraper}>
                <label>שאלת סיכום</label>
                <textarea
                    value={finalQuestion}
                    onChange={(e) => handleFinalQuestionChange(e.target.value)}
                    className='style_inp__eLH4y'
                />
            </div>
        </div>
    );
}

export default ReviewBuilder;
